// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__3IzPT","list":"styles_list__2wtyS"};